module.exports = __webpack_public_path__ + "img/ziyouwangguo5.bc8f91f2.jpg";